module.exports = __webpack_public_path__ + "img/zz2.e57abd95.png";